import { render } from "./AddDefinition.vue?vue&type=template&id=1a54a45c&ts=true"
import script from "./AddDefinition.vue?vue&type=script&lang=ts"
export * from "./AddDefinition.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__